import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Radio, Typography } from "antd";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleUpdateSymptomDuration } from "../../redux-toolkit/slices/painEntryFormSlice";

const TeSymptomDuration = () => {
  const symptomDuration = useSelector(
    (state: RootState) => state.painEntryForm.symptomDuration
  );
  const dispatch = useDispatch();
  const handleSelect = (value: string) => {
    dispatch(handleUpdateSymptomDuration(value));
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Symptom Duration *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Select the option that best describes how long you've been experiencing the symptom.
      </p>
      <Radio.Group
        onChange={(e) => handleSelect(e.target.value)}
        value={symptomDuration}
      >
        {painEntryFormConstants.symptomsDuration.map(
          ({ value, label }) => {
            return (
              <Radio key={value} value={value}>
                {label}
              </Radio>
            );
          }
        )}
      </Radio.Group>
    </div>
  );
};

export default TeSymptomDuration;
